export default __webpack_public_path__ + "static/media/hands.c7b36db4.png";